/* eslint-disable max-len */
import React from 'react';
import { AllieIconProps } from '../../..';

export const AlertMenuSelectedMobileApp = (props: AllieIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path
        d="M13.488 4.85551C14.8978 2.4039 18.4354 2.40402 19.8454 4.85551L30.569 23.5059C31.9745 25.9502 30.2107 29.0007 27.3913 29.001H5.94304C3.12331 29.001 1.35877 25.9503 2.76433 23.5059L13.488 4.85551ZM17.3493 21.9219C16.9389 21.5526 16.3067 21.586 15.9372 21.9961L15.9235 22.0108C15.554 22.4213 15.5872 23.0544 15.9977 23.4239C16.4081 23.7931 17.0404 23.7598 17.4098 23.3497L17.4235 23.334C17.7927 22.9235 17.7596 22.2913 17.3493 21.9219ZM16.6667 11C16.1144 11 15.6667 11.4478 15.6667 12V17.333C15.6667 17.8853 16.1144 18.333 16.6667 18.333C17.219 18.333 17.6667 17.8853 17.6667 17.333V12C17.6667 11.4478 17.219 11 16.6667 11Z"
        fill={props.color || '#131316'}
      />
    </svg>
  );
};
